import { Anchor, Tooltip } from '@mantine/core'
import { buildMc1ClaimUrl } from '../../utils/mc1Url'
import { openExternalUrl } from '../../utils/openExternalUrl'

export interface OpenInMc1LinkProps {
  // The claim number is the link (per MSD-223 feedback) — clicking it opens the
  // claim's case in MC1.
  claimNumber: string
  caseId: number
}

// No nested ternaries (Sonar S3358).
function getTooltip(hasBaseUrl: boolean, hasCaseId: boolean): string {
  if (!hasBaseUrl) return 'MC1 base URL not configured'
  if (!hasCaseId) return 'No MC1 case linked to this claim'
  return 'View claim in MC1'
}

export function OpenInMc1Link({ claimNumber, caseId }: Readonly<OpenInMc1LinkProps>) {
  const baseUrl = import.meta.env.VITE_MC1_BASE_URL as string | undefined
  const hasBaseUrl = Boolean(baseUrl)
  const hasCaseId = Boolean(caseId)
  const disabled = !hasBaseUrl || !hasCaseId

  const handleClick = () => {
    if (!disabled) openExternalUrl(buildMc1ClaimUrl(baseUrl!, caseId))
  }

  return (
    <Tooltip label={getTooltip(hasBaseUrl, hasCaseId)} withArrow>
      <Anchor
        component="button"
        type="button"
        fz="xs"
        underline="always"
        c={disabled ? 'dimmed' : 'brand.7'}
        onClick={handleClick}
        aria-disabled={disabled}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap' }}
      >
        {claimNumber}
      </Anchor>
    </Tooltip>
  )
}
